import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
import $session from "servicestack/session";
import shoppingConfig from "emun.shopping/shopping.config";
import orderConfig from "emun.order/order.config";
import labels from "emun.order/_labels";
import ServiceBus from "servicestack/service-bus";
import Product from "emun.shopping/product.model";
import modals from "webmodals/modals";
import TicketPrompt from "emun.order/ticket-prompt";

const productSorter = scan => (a, b) => {
  const aI = a.id.indexOf(scan);
  const bI = b.id.indexOf(scan);
  if (aI === -1 && bI >= 0) return 1;
  if (bI === -1 && aI >= 0) return -1;
  if (aI >= 0 && bI >= 0 && aI > bI) return 1;
  if (aI >= 0 && bI >= 0 && bI > aI) return -1;
  if (bI === aI && aI >= 0) {
    const skuComp = skuLengthSorter(a, b);
    if (skuComp !== 0) return skuComp;
    return availableQtySorter(a, b);
  }
  return availableQtySorter(a, b);
};
const skuLengthSorter = (a, b) => {
  if (a.id.length > b.id.length) return 1;
  if (b.id.length > a.id.length) return -1;
  return 0;
};
const availableQtySorter = (a, b) => {
  if (a.availableQty > b.availableQty) return -1;
  if (b.availableQty > a.availableQty) return 1;
  return 0;
};

export default class TicketOrderController {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.config = cartConfig;
		$ctrl.orderConfig = orderConfig;
		$ctrl.today = new Date().getTime();
		$ctrl.labels = labels;
		$ctrl.bus = new ServiceBus();
	    $ctrl.prodQuery = new AutoQuery({
			url: "QueryProducts.json?V=Scan&IncludeInactive=1",
			autoLoad: false,
			criteria: {
				//CategoryId: 'FAN'
			},
			pageSize: 48,
			beforeLoading({ request }) {
				request.cartId = $ctrl.$cart.cartId;
			},
			scrub: res =>
			(res.data.results = Product.map(
				res.data.results.sort(productSorter($ctrl.prodQuery.criteria.scan))
			)),
			onLoaded: args => $ctrl.productsLoaded(args)
		});
	}

	loadCart() {
		const $ctrl = this;
		$ctrl.$cart.load($ctrl.orderId).then(function() {
			if ($ctrl.$cart.tagFor && $ctrl.$cart.reasonCode !== "Refund") {
				$ctrl.getProduct($ctrl.$cart.tagFor);
			}
			$ctrl.bus.send("GetTicket.json?Id=" + $ctrl.$cart.purchaseOrder).then(function(res) {
				$ctrl.ticket = res.data.ticket;
				if ($ctrl.$cart.reasonCode === 'Refund') {
					$ctrl.purchasesQuery = new AutoQuery({
						url: "QueryCartItemsJoin.json?TokenizationProvider=SnapPay&CartItemStatus=Completed&CartItemProductIdNotIn=F,T,X,Freight&CartItemPriceGreaterThan=0&CartActive=1&CartItemActive=1&PositionGreaterThan=0&CartOrderedOnGreaterThan=" + moment().add('days',-365).format("MM/DD/YYYY"),
						orderBy: '-CartOrderedOn',
						autoLoad: false,
						pageSize: 1000,
						onLoaded: function(args) {
							args.results.forEach(function(p) {
								p.id = p.productId;
								p.comments = p.cartId + "|" + p.position;
							});
							$ctrl.purchases = Product.map(
								args.results
							);
						}
					});
				}
			});
		});
	}

	$onInit() {
		const $ctrl = this;
		$ctrl.loadCart();
	}
	addItem(p) {
		const $ctrl = this;
		return $ctrl.$cart.addItem(
			p.createCartItem(null, p.comments, 1),
			p,
			true
		).then(res => {
			$ctrl.$emit("cart-item-added", res);
		});
	}
	addReplacement(p) {
		const $ctrl = this;
		$ctrl.bus
			.read("QueryProducts.json", {
				cartId: $ctrl.$cart.cartId,
				id: p.onDemandProductEuid
			})
			.then(res => {
				if (res.data.results.length > 0) {
					var replacement = new Product(res.data.results[0]);
					return $ctrl.$cart.addItem(
						replacement.createCartItem(null, replacement.comments, 1),
						replacement,
						true
					).then(res => {
						$ctrl.$emit("cart-item-added", res);
					});
				}
			});
	}
	removeItem(p) {
		const $ctrl = this;
		let existingItem = $ctrl.$cart.itemIndex[p.id];
		$ctrl.$cart.removeItem(existingItem);
	}
	loadProducts() {
		const $ctrl = this;
		if (($ctrl.prodQuery.criteria.scan || "").length >= 3) {
			$ctrl.$selectedIndex = null;
			//$ctrl.product = null;
			$ctrl.prodQuery.load(true);
		} else {
			$ctrl.products = [];
		}
	}
	getProduct(id) {
		const $ctrl = this;
		if (id) {
			console.info("getProduct", id);
			$ctrl.prodQuery.bus.cancelAll();
			$ctrl.prodQuery.bus
				.read("QueryProducts.json?IncludeInactive=1", {
					cartId: $ctrl.$cart.cartId,
					id
				})
				.then(res => {
					if (res.data.results.length > 0) {
						$ctrl.setProduct(new Product(res.data.results[0]));
					}
				});
		}
	}
	productsLoaded(args) {
		const $ctrl = this;
		$ctrl.products = args.results;
		//$ctrl.product = null;
		$ctrl.$lastScan = $ctrl.prodQuery.criteria.scan;
		if (
			args.results.length === 1 &&
			$ctrl.products[0].id === $ctrl.prodQuery.criteria.scan
		) {
			$ctrl.setProduct(args.first);
		} else if (args.results.length == 0) {
			$ctrl.invalid = true;
		} else {
			$ctrl.$selectedIndex = 0;
		}
	}
	moreInfo() {
		const $ctrl = this;
		modals.alert("Need Salsify Link");
	}

	canAdd(product) {
		const $ctrl = this;
		var availDate = product.availableOn ? moment(product.availableOn, 'MM/DD/YYYY') : moment().add(365, 'days');
		var today = moment().startOf('day');
		var availDays = availDate.diff(today, 'days');
		var ret = false;
		if (product.availableQty !== 'X') {
			switch (product.meta["Status"]) {
				case 'NEW':
					switch ($ctrl.$cart.reasonCode) {
						case 'Warranty':
							if (product.availableQty > 0 && product.availableQty !== 'X') ret = true;
							break;
						default:
							if ((product.availableQty > 0 && product.availableQty !== 'X') || availDays <= 45) ret = true;
							break;
					}
					break;
				case 'ACT':
					if ((product.availableQty > 0 && product.availableQty !== 'X') || availDays <= 45) ret = true;
					break;
				case 'DNR':
					if ((product.availableQty > 0 && product.availableQty !== 'X') || availDays <= 45) ret = true;
					break;
				case 'DIS':
					if ((product.availableQty > 0 && product.availableQty !== 'X') || availDays <= 45) ret = true;
					break;
			}
		}
		return ret;
	}

	setProduct(p) {
		const $ctrl = this;
		console.info("setProduct", p);
		$ctrl.products = [];
		$ctrl.$selectedIndex = null;
		$ctrl.invalid = false;
		$ctrl.product = p;
		if ($ctrl.$cart.reasonCode === "Warranty") {
			$ctrl.product.price = 0;
		}
		$ctrl.bus.send("GetAvailability.json", {ProductIds: $ctrl.product.id}).then(function(response) {
			if (response.data.products) {
				$ctrl.product.availableQty = response.data.products[0].quantityAvailable;
				var availDate = response.data.products[0].estimatedAvailableDate;
				if (availDate !== "") {
					$ctrl.product.availableOn = availDate.substring(4,6) + "/" + availDate.substring(6,8) + "/" + availDate.substring(0,4);
				}
			} else {
				$ctrl.product.availableQty = "X";
			}
			$ctrl.product.canAdd = $ctrl.canAdd($ctrl.product);
		});
		$ctrl.quantity = $ctrl.product.minimumOrderQty || 1;
		$ctrl.product.qtyIncrement = $ctrl.product.purchaseIncrement || 1;
		$ctrl.product.shipDate = $ctrl.$cart.shipOn;
		$ctrl.prodQuery.criteria.scan = "";
		$ctrl.parts = [];
		if ($ctrl.product.parts) {
			$ctrl.productIds = $ctrl.product.parts.map(part => part.ProductId);
			if ($ctrl.productIds != "") {
				$ctrl.partsQuery = new AutoQuery({
					url: 'QueryProducts.json',
					criteria: {
						IncludeInactive: true,
						cartId: $ctrl.$cart.cartId,
						IdIn: $ctrl.productIds
					},
					orderBy: 'Id',
					autoLoad: true,
					pageSize: 1000,
					onLoaded: function(args) {
						$ctrl.parts = args.results = Product.map(
							args.results
						);
						if ($ctrl.$cart.reasonCode == "Warranty") {
							$ctrl.parts.forEach(function(p) {
								p.price = 0;
								p.availableQty = "X";
							});
						}
						$ctrl.parts.forEach(function(p) {
							$ctrl.bus.send("GetAvailability.json", {ProductIds: p.id}).then(function(response) {
								if (response.data.products) {
									p.availableQty = response.data.products[0].quantityAvailable;
									var availDate = response.data.products[0].estimatedAvailableDate;
									if (availDate !== "") {
										p.availableOn = availDate.substring(4,6) + "/" + availDate.substring(6,8) + "/" + availDate.substring(0,4);
									}
								} else {
									p.availableQty = "X";
								}
								p.canAdd = $ctrl.canAdd(p);
								if ((p.meta["Status"] == "OB2" || p.meta["Status"] == "DIS" || p.meta["Status"] == "NFS") && p.onDemandProductEuid) {
									p.hasReplacement = true;
								}
							});
						});
					}
				});
			}
		}		
		if (($ctrl.product.meta["Status"] == "OB2" || $ctrl.product.meta["Status"] == "DIS" || $ctrl.product.meta["Status"] == "NFS") && $ctrl.product.onDemandProductEuid) {
			//modals.alert("The model you have entered has been replaced by " + $ctrl.product.onDemandProductEuid + ".  Please update your records for future reference");
			//$ctrl.getProduct($ctrl.product.onDemandProductEuid);
			$ctrl.product.hasReplacement = true;
		} else if ($ctrl.product.meta["Status"] == "OB2") {
			modals.alert("The model you have entered is obsolete");
			$ctrl.product = {};
		}
	}
	ticketPrompt() {
		const $ctrl = this;
		TicketPrompt({ ticket: $ctrl.ticket }).then(function() {
			$ctrl.loadCart();
//			$ctrl.$cart.load();
		});
	}
	replacement() {
		const $ctrl = this;
		$ctrl.getProduct($ctrl.product.onDemandProductEuid);
	}

}
